import gql from 'graphql-tag';

export const ProjectPermissionsFields = gql`
	fragment ProjectPermissionsFields on ProjectPermissions {
		commenting
		invite
		showDiscount
		editProject
	}
`;
